import { createLogger } from '@core/utils/console'
import PropTypes from 'prop-types'
import React from 'react'

const logAction = createLogger('red')

export const LoggerContext = React.createContext()
LoggerContext.displayName = 'LoggerContext'

export const useLoggerContext = () => React.useContext(LoggerContext)

class Logger extends React.Component {

  static childContextTypes = {
    logger: PropTypes.object
  }

  static propTypes = {
    children: PropTypes.any
  }

  _handleError = this._handleError.bind(this)
  _handleSignin = this._handleSignin.bind(this)

  render() {
    const { children } = this.props
    return (
      <LoggerContext.Provider value={ this.getChildContext() }>
        { children }
      </LoggerContext.Provider>
    )
  }

  componentDidMount() {
    if(process.env.MAHA_ENV !== 'production') return
  }

  getChildContext() {
    return {
      logger: {
        error: this._handleError,
        log: this._handleLog,
        signin: this._handleSignin
      }
    }
  }

  _handleLog(action, data) {
    logAction(action, data)
  }

  _handleSignin(user) {}

  _handleError(error, info) {}

}

export default Logger
